export default __webpack_public_path__ + "static/media/HourglassMedium-icon.31524c42.svg";